import type { MessageKey } from 'types/LocaleMessageKey';

import {
  AMBASSADOR_PROGRAM_FORM_ID,
  API_INTEGRATION_FORM_ID,
  CORPORATE_WELLNESS_FORM_ID,
  GIFTING_AND_EVENTS_FORM_ID,
  HEALTHCARE_FORM_ID,
  MILITARY_FORM_ID,
  RESEARCH_FORM_ID,
  SPORTS_FORM_ID,
} from '@/app/[locale]/business/_data/const';

export interface RadioOption {
  formId: string;
  label: MessageKey;
  href?: string;
}

export const radioOptions: RadioOption[] = [
  {
    formId: HEALTHCARE_FORM_ID,
    label: 'healthcare',
  },
  {
    formId: RESEARCH_FORM_ID,
    label: 'research',
  },
  {
    formId: CORPORATE_WELLNESS_FORM_ID,
    label: 'corporate_wellness',
  },
  {
    formId: SPORTS_FORM_ID,
    label: 'sports',
  },
  {
    formId: GIFTING_AND_EVENTS_FORM_ID,
    label: 'gifting_and_events',
  },
  {
    formId: MILITARY_FORM_ID,
    label: 'military',
  },
  {
    formId: API_INTEGRATION_FORM_ID,
    href: 'https://cloud.ouraring.com/v2/docs',
    label: 'api_integration',
  },
  {
    formId: AMBASSADOR_PROGRAM_FORM_ID,
    href: 'https://s.ouraring.com/join-ouras-ambassador-program',
    label: 'ambassador_program',
  },
];
